<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">เติมเครดิตเข้ากระเป๋า</h1>
                    <p class="text-white pb-3 px-3">เลือกจำนวนเครดิต หรือ ระบุจำนวนเครดิต เพื่อทำการเติมเข้ากระเป๋าของคุณ</p>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="row justify-content-md-center">
                            <template v-if="!statusPaymant">
                                <div class="col-12 col-lg-12 px-6">
                                    <h3>โปรดเลือกจำนวนที่ต้องการเติม (1 เครดิต = 1 บาท)</h3>
                                    <div class="row text-center">
                                        <div class="col-lg-4 py-3" v-for="(num , index) in topUp.amount_options" :key="index">
                                            <b-button
                                                variant="outline-dark"
                                                class="btn-block"
                                                :class="{'radio-box-active': totalAmount == num.value}"
                                                @click="totalAmount = num.value"
                                                size="lg"
                                            >
                                                {{num.text}}
                                            </b-button>
                                        </div>
                                    </div>
                                    <template v-if="totalAmount == 'OTHER'">
                                        <h4>ระบุจำนวนเครดิต ( 1 เครดิต = 1 บาท)</h4>
                                        <input
                                            v-model="fillAmount"
                                            type="number"
                                            class="form-control hide-arrow"
                                            :class="{ 'is-invalid': $v.fillAmount.checkFillAmount }"
                                            :min="topUp.amount_minimum"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                            @change="checkTopupAmount"
                                            :placeholder="('ขั้นต่ำในการเติม: ' + topUp.amount_minimum + ' เครดิต สูงสุดไม่เกิน 50,000 เครดิต')"
                                        />
                                        <label class="invalid-feedback" v-if="$v.fillAmount.checkFillAmount">
                                            * ยอดเครดิตที่ต้องการเติมไม่ถูกต้อง กรุณาระบุจำนวนเครดิตเป็นเลขจำนวนเต็ม เช่น 100, 1200, 20000
                                        </label>
                                        <small class="text-muted" v-else>
                                            โปรดระบุจำนวนเครดิตเป็นเลขจำนวนเต็มโดยมีขั้นต่ำ {{ topUp.amount_minimum }} เครดิต และสูงสุดไม่เกิน 50,000 เครดิต
                                        </small>
                                    </template>
                                    <div class="row text-center">
                                        <div class="col-12 col-lg-12 col-xl-12 col-md-12 py-5">
                                            <div class="pb-4">
                                                <b-form-checkbox
                                                    v-model="condition"
                                                    :value="true"
                                                    :unchecked-value="false"
                                                >
                                                    ฉันยอมรับ <u>ข้อตกลงและเงื่อนไขการใช้บริการ</u>
                                                </b-form-checkbox>
                                            </div>
                                            <b-button class="px-5" variant="primary" :disabled="!totalAmount || !condition || isLoadingTopUp" @click="funcPopupCredit()">
                                                <i class="fas fa-circle-notch fa-spin" v-if="isLoadingTopUp"></i> เติมเครดิต
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-12 col-lg-12 px-6 text-center pb-4">
                                    <i class="fas fa-check-circle fa-5x text-success" v-if="statePaymant == 'CONFIRM'"></i>
                                    <i class="fas fa-clock fa-5x text-info" v-else></i>
                                    <p v-if="statePaymant == 'CONFIRM'">เติมเครดิตสำเร็จแล้ว</p>
                                    <p v-else>รอดำเนินการ</p>
                                    <h2 class="text-success">+{{ ((this.totalAmount == 'OTHER') ? this.fillAmount : this.totalAmount) | numFormat('0,0.00') }} เครดิต</h2>
                                    <hr class="my-4" />
                                    <!-- <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <h4>วิธีการชำระ</h4>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h4>ชำระผ่าน QR CODE</h4>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h4>วันที่เวลาที่ทำรายการ</h4>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h4>02/06/21 17:04</h4>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h4>หมายเลขการทำรายการ</h4>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h4>0980980284434534</h4>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <b-button class="px-5 mr-4">ดูใบเสร็จ</b-button> -->
                                    <router-link to="/pos">
                                        <b-button class="px-5" variant="primary">กลับสู่หน้าหลัก</b-button>
                                    </router-link>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalPaymentWallet ref="payment" :paymentWallet="paymentWallet" @topupSuccess="topupSuccess()"/>
    </div>
</template>
<script>
import ModalPaymentWallet from '@/components/Modals/ModalPaymentWallet'
import { hexToRgbA } from "@/plugins/hexColor.js";
import configPOPTheme from '@/config/POPTheme'
import {
    fetchWalletBanlancesToLocalStorage,
    checkFillAmount
} from "@/axios/walletPayment.js"

export default {
    name: "topupcredit",
    components:{
        ModalPaymentWallet
    },
    data() {
        return {
            condition    : false,
            totalAmount  : '',
            fillAmount   : '',
            paymentWallet: {
                show      : false,
                urlPayment: ''
            },
            topUp: {
                amount_minimum: configPOPTheme.MIN_WALLET_TOPUP || 100,
                amount_options: configPOPTheme.WALLET_AMOUNT || [
                    { text:'100' , value: 100 },
                    { text:'200' , value: 200 },
                    { text:'300' , value: 300 },
                    { text:'500' , value: 500 },
                    { text:'1000' , value: 1000 },
                    { text:'2000' , value: 2000 },
                    { text:'3000' , value: 3000 },
                    { text:'5000' , value: 5000 },
                    { text:'ระบุจำนวนเครดิต' , value: 'OTHER' },
                ],
            },
            walletInfo:{},
            statusPaymant: false,
            statePaymant:'',
            isLoadingTopUp: false,

            funcPopupCredit: null
        }
    },
    created() {
        if (!this.main_is_production) {
            this.topUp.amount_minimum = 1
            this.topUp.amount_options.unshift(
                { text:'1' , value: 1 },
                { text:'2' , value: 2 },
                { text:'5' , value: 5 }
            )
        }
    },
    mounted() {
        this.assignFuncPopupCredit();
    },
    validations: {
        fillAmount: { checkFillAmount }
    },
    methods: {
        checkTopupAmount() {
            const maxAmount = 50000;
            if (this.fillAmount < this.topUp.amount_minimum) {
                this.fillAmount = this.topUp.amount_minimum
                return true;
            }else if( this.fillAmount > maxAmount ){
                this.fillAmount = maxAmount
                return true;
            }else {
                return false
            }
        },
        popupCredit(){
            if (this.$v.fillAmount.checkFillAmount ){
                return false
            }

            this.isLoadingTopUp = true
            this.$http
                .post(this.$API_URL + "/wallet/agent/transaction/pgw/deposit", {
                    credit: (this.totalAmount == 'OTHER') ? this.fillAmount : this.totalAmount
                }, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                    .then(res => {
                        if(!res.data.status){
                            return false
                        }
                        this.paymentWallet.urlPayment = res.data.data.url

                        this.paymentWallet.show = true
                        this.isLoadingTopUp     = false
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        // this.isLoadingTopUp = false
                    })
        },
        popupCreditWalletV2(){
            if (this.$v.fillAmount.checkFillAmount ){
                return false
            }

            this.isLoadingTopUp = true
            this.$http
                .post(this.$API_URL + "/wallet_v2/agent/transaction/deposit/pending/pgw", {
                    credit: (this.totalAmount == 'OTHER') ? this.fillAmount : this.totalAmount
                }, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                    .then(res => {
                        if(!res.data.status){
                            return false
                        }
                        this.paymentWallet.urlPayment = res.data.data.url

                        this.paymentWallet.show = true
                        this.isLoadingTopUp     = false
                    })
                    .catch()
                    .finally()
        },
        topupSuccess(state) {
            this.statusPaymant = true
            this.statePaymant  = state
            if (this.statePaymant === 'CONFIRM') {
                fetchWalletBanlancesToLocalStorage(this.main_use_walletV2).then(res => {
                    this.$WALLET.available_balance = res.available_balance
                    this.$WALLET.balance           = res.balance
                    this.$WALLET.peg_balance       = res.peg_balance
                });
            }

            this.paymentWallet.show = false
        },

        assignFuncPopupCredit() {
            if (this.main_use_walletV2) {
                this.funcPopupCredit = this.popupCreditWalletV2;
            } else {
                this.funcPopupCredit = this.popupCreditWallet;
            }
        }
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': (this.$THEME.name == 'shippop') ? hexToRgbA('#11cdef' , 0.7) : hexToRgbA(this.$THEME.primaryColor, 0.7),
                '--bg-color' : (this.$THEME.name == 'shippop') ? '#11cdef' : this.$THEME.primaryColor,
            }
        }
    }
};
</script>
<style scoped>
.btn-outline-dark:hover {
    color: #ffffff;
    background-color: var(--bg-hover-color);
    border-color: var(--bg-color);
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active{
    color:#ffffff;
    background-color: var(--bg-hover-color);
    border-color: var(--bg-color);
}
.btn-outline-dark {
    border-color: #cad1d7;
}
.radio-box-active{
  background-color: var(--bg-color);
  color: #ffffff;
}
</style>
